export enum OrderType {
  KIT = 'KIT',
  KIT_BATCH_STOCK = 'KIT_BATCH_STOCK',
  KIT_BATCH = 'KIT_BATCH',
  PICKUP = 'PICKUP',
  AT_HOME = 'AT_HOME',
  PRE_ORDER = 'PRE_ORDER',
}
